import { createContext, useEffect, useState } from "react";

import {
  sortOrders,
  updateOrderItems,
  orderProcessing,
  updateOrderStatus,
} from "../utils/restaurantOrder";
export const OrdersContext = createContext({});

export const OrdersProvider = ({ children }) => {
  const [ordersContext, setOrdersContext] = useState({});
  const [preparingOrders, setPreparingOrders] = useState({});
  const [doneOrders, setDoneOrders] = useState({});
  const [placedOrders, setPlacedOrders] = useState({});
  const [tableSideOrders, setTableSideOrders] = useState({});
  const [takeawayOrders, setTakeawayOrders] = useState({});
  const [tableCount, setTableCount] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [orderItems, setOrderItems] = useState({});
  const totalTables = 15;

  useEffect(() => {
    const getOrders = async () => {
      const hotelIDValue = localStorage.getItem("hotelID");
      const requestObject = {
        hotelID: hotelIDValue,
      };
      try {
        const response = await fetch(
          "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/order/getorders",
          {
            method: "POST",
            headers: {
              "Content-type": "application/json",
            },
            body: JSON.stringify(requestObject),
          }
        );
        const result = await response.json();
        var tempObject = {};
        var count = 0;
        result.map((index) => {
          tempObject = { ...tempObject, [count]: index };
          count++;
        });
        setOrdersContext(tempObject);
      } catch (error) {
        console.log(error.message);
      }
      setTimeout(() => {
        getOrders();
      }, 10000);
    };
    getOrders();
  }, []);
  useEffect(() => {
    if (Object.keys(preparingOrders).length > 0) {
      updateOrderItems(preparingOrders, setOrderItems);
    }
  }, [preparingOrders]);
  useEffect(() => {
    var tables = {};
    Object.keys(tableSideOrders).map((index) => {
      const tempObject = tableSideOrders[index];
      if (!tables[tempObject["tableNumber"]]) {
        tables = { ...tables, [tempObject["tableNumber"]]: "" };
      }
    });
    setTableCount(Object.keys(tables).length);
  }, [tableSideOrders]);
  useEffect(() => {
    orderProcessing(
      ordersContext,
      setTotalRevenue,
      setTableSideOrders,
      setTakeawayOrders
    );
    sortOrders(
      ordersContext,
      setPlacedOrders,
      setPreparingOrders,
      setDoneOrders
    );
  }, [ordersContext]);

  const changeOrderStatus = (orderID, status) => {
    var tempOrder = ordersContext[orderID];
    tempOrder = { ...tempOrder, ["status"]: status };
    updateOrderStatus(tempOrder["_id"], status);
    setOrdersContext({ ...ordersContext, [orderID]: tempOrder });
  };

  const value = {
    tableSideOrders,
    takeawayOrders,
    ordersContext,
    setOrdersContext,
    tableCount,
    totalTables,
    totalRevenue,
    changeOrderStatus,
    orderItems,
    setOrderItems,
    preparingOrders,
    doneOrders,
    placedOrders,
  };
  return (
    <OrdersContext.Provider value={value}>{children}</OrdersContext.Provider>
  );
};
